import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceSetting from "@/views/系统设置/service/DZServiceSetting";
import DZModelSetting from "@/views/系统设置/model/DZModelSetting";

@Component({
    components: {}
})

export default class Index extends Vue {

    $refs: any;

    table_height = 0;

    s_setting = new DZServiceSetting();

    is_dialog_show = false;

    is_edit = false;

    created() {
        this.action_list_data()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    action_list_data(){
        this.s_setting.net_list_setting();
    }

    handleSizeChange(val){
        this.s_setting.m_page.pageSize = val
        this.action_list_data()
    }

    handle_add(){
        this.is_edit = false
        this.is_dialog_show = true
    }

    dialog_close(){
        this.s_setting.m_setting = new DZModelSetting();
        this.is_dialog_show = false
    }

    handle_submit(){
        if (this.is_edit) {
            this.s_setting.net_edit_setting(() => {
                this.action_list_data()
                this.dialog_close()
            });
        } else {
            this.s_setting.net_add_setting(() => {
                this.action_list_data()
                this.dialog_close()
            });
        }
    }

    handle_edit(row){
        this.s_setting.m_setting = Object.assign({},row)
        this.is_edit = true
        this.is_dialog_show = true
    }

    handleDbClick(row){
        if(row){
            this.handle_edit(row)
        }
    }
}
